import { Component, Input } from '@angular/core';
import { FormComponentLookup, FormPageComponentClass, FormConfig, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { setPlanChange } from '../../../../plan-selection/configs/reducers/plans.reducer';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { PersonalInfoStateStructure } from '../../../../shared/interfaces/personalInfoStateStructure.interface';
import { ZipCountyStateStructure } from '../../../../shared/interfaces/zipCountyStateStructure.interface';

@FormComponentLookup('page-plan-change-start-review')
@Component({
    selector: 'app-page-plan-change-start-review',
    templateUrl: './page-plan-change-start-review.component.html',
    styleUrls: ['./page-plan-change-start-review.component.scss'],
    standalone: false
})
export class PagePlanChangeStartReviewComponent extends FormPageComponentClass<FormNavigationConfig> {

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private commonUtilityService: CommonUtilityService
  ) {
    super();
  }

  ngOnInit() {
    this.initPageConfig();
  }

  submitHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this.formConfig.form.customConfigs?.viewPlansUrl){
        console.warn('no url provided in formConfig.form.customConfigs.viewPlansUrl');
        reject();
        return;
      }

      // Just in case the member was changing address, re-brand on the updated address
      let zipState: ZipCountyStateStructure = this.reducerUtilityService.getComponentStates().ZipCounty;
      this.commonUtilityService.saveCountyZipData(zipState.county, zipState.zipCode);

      this.ngRedux.dispatch(setPlanChange(true));
      window.location.href = this.formConfig.form.customConfigs.viewPlansUrl;

      resolve(true);
    });
  }
}

